import { CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ADMIN_CONSTANT } from '../app.model';
import { AppService } from '../app.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  constructor(private router: Router, private service: AppService) {}

  canActivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.service.adminConfig) {
      this.router.navigate(['offline'], {
        replaceUrl: true,
      });
      return false;
    }

    if (
      this.service.adminConfig.find(
        (r) =>
          r.ConfigCode === ADMIN_CONSTANT.SITE_UNDER_MAINTENANCE &&
          !!r.ConfigValue &&
          r.ConfigValue === 'TRUE'
      )
    ) {
      this.router.navigate(['maintenance'], {
        replaceUrl: true,
      });
      return false;
    }

    if (
      !!this.service.getToken(ADMIN_CONSTANT.ADMIN_TOKEN_AUTH_TOKEN) &&
      !!this.service.getToken(
        ADMIN_CONSTANT.ADMIN_TOKEN_ADMIN_SELECTED_ORGANIZATION
      )
    ) {
      this.router.navigate(['dashboard'], { replaceUrl: true });
      return false;
    }

    return true;
  }
}
